import axios from 'axios';

const settingsService = {
  async getSetting(key) {
    try {
      const response = await axios.get(`/api/v1/settings/${key}`);
      return response.data.value;
    } catch (error) {
      console.error(`Error fetching setting ${key}:`, error);
      return null;
    }
  },

  async updateSetting(key, value) {
    try {
      const response = await axios.put(`/api/v1/settings/${key}`, value);
      return response.data;
    } catch (error) {
      console.error(`Error updating setting ${key}:`, error);
      throw error;
    }
  },
};

export default settingsService;
